<template>
  <div>
    <div class="b-card">
      <div class="b-card-title">Kunduppgifter</div>

      <dl class="b-summary-grid">
        <div v-for="f in customerFields" :key="f.key" class="b-summary-item">
          <dt>{{ f.label }}</dt>
          <dd>{{ value(f.value(source)) }}</dd>
        </div>
      </dl>

      <div v-if="customer.information" class="b-summary-note">
        <div class="b-summary-note-label">Övrig information</div>
        <div>{{ customer.information }}</div>
      </div>

      <section v-for="(form, index) in forms" :key="index" class="b-summary-well">
        <h3 class="b-summary-well-title">
          Brunn {{ index + 1 }}<template v-if="form.littera"> — {{ form.littera }}</template>
        </h3>

        <dl class="b-summary-grid">
          <div v-for="f in wellFields" :key="f.key" class="b-summary-item">
            <dt>{{ f.label }}</dt>
            <dd>{{ value(f.value(form)) }}</dd>
          </div>
        </dl>

        <div class="b-table-scroll">
          <table class="b-table">
            <thead>
              <tr>
                <th v-for="c in connectionColumns" :key="c.key">{{ c.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in form.items" :key="i">
                <!-- Sandfång/Stalp lämnas blanka när de saknas – bara ett av
                     dem är relevant per rad, ett '—' där ser ut som ett fel. -->
                <td v-for="c in connectionColumns" :key="c.key">
                  {{ optional(c) ? c.value(item) || '' : value(c.value(item)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="b-card">
      <div class="b-card-title">Skicka in</div>
      <p>
        Skicka ditt underlag till
        <a class="link" href="mailto:offert@benders.se">offert@benders.se</a>
        för att få en offert, eller till
        <a class="link" href="mailto:order@benders.se">order@benders.se</a>
        för att genomföra en beställning.
      </p>
    </div>
  </div>
</template>

<script>
import { customerFields, wellFields, connectionColumns } from '@/formFields.js'

export default {
  name: 'StepSummary',
  props: {
    customer: { type: Object, required: true },
    common: { type: Object, required: true },
    forms: { type: Array, required: true },
  },
  data() {
    return { customerFields, wellFields, connectionColumns }
  },
  computed: {
    // customerFields hämtar ur { customer, common } – samma form som store.
    source() {
      return { customer: this.customer, common: this.common }
    },
  },
  methods: {
    value(v) {
      return v === '' || v === null || v === undefined ? '—' : v
    },
    // Kolumner där tomt är det normala, inte en lucka att markera.
    optional(column) {
      return column.key === 'sandfang' || column.key === 'stalp'
    },
  },
}
</script>
